import { render } from "./EnrolleeClientComponent.vue?vue&type=template&id=2b7924dc&scoped=true"
import script from "./EnrolleeClientComponent.vue?vue&type=script&lang=js"
export * from "./EnrolleeClientComponent.vue?vue&type=script&lang=js"

import "./EnrolleeClientComponent.vue?vue&type=style&index=0&id=2b7924dc&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-2b7924dc"]])

export default __exports__